const Card = ({ title, value, color }) => {
  return (
    <div
      className={`p-4 ${color} text-white rounded-lg shadow-md text-center  transition-all duration-300 hover:scale-105`}
    >
      <h2 className="text-lg font-semibold">{title}</h2>
      <p className="text-3xl font-bold">{value}</p>
    </div>
  );
};

export default Card;
